import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#31a63d',
        secondary: '#0288D1',
        accent: '#000000'
      },
      dark: {
        primary: '#34833D',
        secondary: '#409BFF'
      }
    }
  }
})
